import HelpPage from 'help/components';
import HelpCategory from 'help/containers/category';
import HelpArticle from 'help/containers/article';
import HelpHome from 'help/containers/home';
import HelpSearch from 'help/containers/search_results';
import AllHelpGuides from 'help/containers/all_guides';
import HelpGuide from 'help/containers/guide';
import ContactHelp from 'help/containers/contact';

export {
  HelpCategory, HelpHome, HelpArticle, HelpSearch, AllHelpGuides, HelpGuide,
  ContactHelp,
};
export default HelpPage;



// WEBPACK FOOTER //
// ./help/index.js